import { ModalWrapper } from '../../components/ModalWrapper.js'
import { ProcessingPaymentPage } from '../ProcessingPaymentPage.js'

export const ProcessingPaymentPortal = () => {
  return (
    <ModalWrapper>
      <ProcessingPaymentPage />
    </ModalWrapper>
  )
}
